import { CopilotUploadPreset } from 'shared/types/copilot'
import { Gradient } from 'types'
import { CopilotPresetAlert, CopilotPresetAlertInputSettings } from '../types'

export const DEFAULT_INPUT_SETTINGS: CopilotPresetAlertInputSettings = { visible: false }

export function titleFromPresetAlert(alert: CopilotPresetAlert): string {
    switch (alert) {
        case 'delete':
            return 'Deleting Preset'
        case 'duplicate':
            return 'Duplicating Preset'
        case 'remove':
            return 'Removing Preset'
        case 'rename':
            return 'Renaming Preset'
        case 'reset':
            return 'Resetting All Fields'
        case 'revert':
            return 'Reverting Changes'
        case 'overwrite':
            return 'Overwriting Changes'
        case 'update':
            return 'Updating Preset'
    }
}

export function descriptionFromPresetAlert(alert: CopilotPresetAlert): string {
    switch (alert) {
        case 'delete':
            return 'This preset will be deleted and will no longer be accessible for any users.'
        case 'duplicate':
            return 'This preset will be duplicated with all the same values. Adjust the preset name or hit "duplicate."'
        case 'overwrite':
            return 'Applying this preset will overwrite any changes that you have made.'
        case 'remove':
            return 'This preset will be removed from your list.'
        case 'reset':
            return 'All fields will be reset to their default values and your changes will be lost.'
        case 'revert':
            return 'All fields will be reverted to the saved preset values and your changes will be lost.'
        case 'update':
            return 'This preset will be updated with the current values set in upload.'
        default:
            return ''
    }
}

export function continueGradientFromPresetAlert(alert: CopilotPresetAlert): Gradient {
    switch (alert) {
        case 'delete':
        case 'remove':
            return 'red-pink'
        default:
            return 'indigo-purple'
    }
}

export function continueLabelFromPresetAlert(alert: CopilotPresetAlert): string {
    switch (alert) {
        case 'delete':
            return 'Delete'
        case 'duplicate':
            return 'Duplicate'
        case 'overwrite':
            return 'Apply Preset'
        case 'remove':
            return 'Remove'
        case 'rename':
            return 'Rename'
        case 'update':
            return 'Update'
        case 'reset':
            return 'Reset All Fields'
        case 'revert':
            return 'Revert Changes'
    }
}

export function inputSettingsFromPresetAlert(
    alert: CopilotPresetAlert,
    preset?: CopilotUploadPreset
): CopilotPresetAlertInputSettings {
    switch (alert) {
        case 'duplicate':
            return {
                defaultValue: `${preset?.name} copy`,
                placeholder: 'Enter Preset Name',
                required: true,
                visible: true,
            }
        case 'rename':
            return {
                defaultValue: preset?.name,
                placeholder: 'Enter Preset Name',
                required: true,
                visible: true,
            }
        default:
            return { visible: false }
    }
}
